export default import.meta.ROLLDOWN_FILE_URL_9a_Sll0J3_WTqljGgO8_pQ